import React, { Suspense } from 'react';

import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';
import { containerVariants } from '../../shared/constants';
import Header from '../../components/common/header';
import Footer from '../../components/common/footer';
import { SplashLoader } from '../../components/common/SplashLoader';
const Root: React.FC = () => {
    const location = useLocation();
    return (
        <section style={{ display: 'flex', flexDirection: "column", minHeight: "100vh" }}>
            <Header />
            <AnimatePresence mode="wait">
                <motion.div
                    key={location.pathname}
                    variants={containerVariants}
                    initial="initialLoad"
                    animate="fullLoad"
                    exit="offLoad"
                    style={{ flex: 1 }}
                >
                    <Suspense fallback={<SplashLoader />}>
                        <Outlet />
                    </Suspense>
                </motion.div>
            </AnimatePresence>
            <Footer />
        </section>

    )
}

export default Root
